import { urlApiTegra, get } from "../../../service/api";

const getHistory = (token: string, queryString?: string) => {
  return get(queryString ? `${urlApiTegra}/professional-historic${queryString}` : `${urlApiTegra}/professional-historic`, token);
};

export const serviceHistory = {
  getHistory,
};
